var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "core-js/modules/es6.function.name", "react", "prop-types", "classnames", "./Icon.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("core-js/modules/es6.function.name"), require("react"), require("prop-types"), require("classnames"), require("./Icon.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.es6Function, global.react, global.propTypes, global.classnames, global.Icon);
    global.Icon = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _es6Function, _react, _propTypes, _classnames, _Icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  var Icon = function Icon(_ref) {
    var className = _ref.className,
        color = _ref.color,
        colorTone = _ref.colorTone,
        name = _ref.name,
        size = _ref.size,
        title = _ref.title;
    // add aria-hidden = true & focusable= false (for IE) if the icon is purely decorative
    // otherwise, add a title
    // see https://css-tricks.com/accessible-svgs/
    var spanAttributes = {
      title: title
    };
    return /*#__PURE__*/_react.default.createElement(_Icon.StyledIcon, (0, _extends2.default)({
      className: (0, _classnames.default)('next-icon', className)
    }, spanAttributes), title && /*#__PURE__*/_react.default.createElement(_Icon.StyledTitle, null, title), /*#__PURE__*/_react.default.createElement(_Icon.StyledSvg, {
      aColor: color,
      colorTone: colorTone,
      "aria-hidden": true,
      focusable: "false",
      className: (0, _classnames.default)('arte-icon', name),
      tabIndex: -1,
      size: size
    }, /*#__PURE__*/_react.default.createElement("use", {
      xlinkHref: "#".concat(name)
    })));
  };

  Icon.propTypes = {
    className: _propTypes.default.string,
    color: _propTypes.default.string,
    colorTone: _propTypes.default.string,
    name: _propTypes.default.string.isRequired,
    size: _propTypes.default.oneOf(['xxsmall', 'xsmall', 'small', 'mediumSmall', 'medium', 'large', 'xlarge', 'xxlarge', 'custom', 'responsive']),
    title: _propTypes.default.string
  };
  Icon.defaultProps = {
    className: '',
    color: '',
    colorTone: null,
    name: '',
    size: 'medium',
    title: ''
  };
  var _default = Icon;
  _exports.default = _default;
});